// extracted by mini-css-extract-plugin
export var anchor = "bf_fl";
export var anchors = "bf_fk";
export var document = "bf_fp";
export var documents = "bf_fn";
export var heading = "bf_G";
export var privacy = "bf_fm";
export var section = "bf_d";
export var tariff = "bf_fr";
export var tariffs = "bf_fq";